export default __webpack_public_path__ + "static/media/bobo-store-login.e7c30738.png";